export default __webpack_public_path__ + "static/media/box.56d21033.gif";